import TrashIcon from "@/assets/SVG/trashIcon";
import { Loader } from "@/components";
import CustomTable from "@/components/customTable/CustomTable";
import { Grid, IconButton, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getMyTrips, removeTripFromProject } from "../../api/group";
import { getAllTrip } from "../../api/trip";
import EditIcon from "../../assets/SVG/editIcon";
import CreateTripPop from "./createTripPop";
import DeleteAlertModal from "./deleteAlertModal";

export default function TripsPage() {
  const [dataTrips, setDataTrips] = useState();
  const [dataTripClick, setDataTripClick] = useState();
  const [deleteModal, setDeleteModal] = useState();
  const [loading, setLoading] = useState(false);
  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalElements, setTotalElements] = useState();
  const [tripDigest, setTripDigest] = useState();

  const colDefs = useMemo(
    () => [
      {
        field: "name",
        headerName: "نام",
        width: 200,
      },
      {
        field: "project",
        headerName: "نام پروژه",
        width: 150,
      },
      {
        headerName: "بازه",
        width: 230,
        cellRenderer: (x) => {
          return (
            <Typography
              key={`date_${x.id}`}
              fontFamily={"Vazirmatn"}
              sx={{ lineHeight: "unset" }}
            >
              {`${x?.data?.startAt.split(" - ")[0]} - ${x?.data?.endAt.split(" - ")[0]}`}
            </Typography>
          );
        },
      },
      {
        headerName: "منطقه/مناطق",
        width: 450,
        cellRenderer: (x) => {
          return (
            <Grid
              key={`area_${x.id}`}
              display={"flex"}
              flexDirection={"row"}
              gap={"5px"}
              mt={"10px"}
            >
              {x?.data?.areas?.map((area, index) => (
                <Typography
                  fontFamily={"Vazirmatn"}
                  variant="caption"
                  key={`area_name_${index}`}
                  sx={{
                    backgroundColor: "var(--emr-custom-blue)",
                    color: "var(--emr-custom-blue-text)",
                    padding: "2px 8px",
                    borderRadius: "8px",
                  }}
                >
                  {area.name}
                </Typography>
              ))}
            </Grid>
          );
        },
      },
      {
        field: "عملیات",
        width: 120,
        cellRenderer: (x) => {
          return (
            <Grid>
              <IconButton
                onClick={() =>
                  setTripDigest({
                    id: x.data.id,
                    name: x.data.name,
                    areas: x.data.areas.map((area) => ({
                      id: area.id,
                      name: area.name,
                      owner: area.owner.id,
                    })),
                    startAt: x.data.startAt,
                    endAt: x.data.endAt,
                    dailyStartAt: x.data.startAt.split(" - ")[1],
                    dailyEndAt: x.data.endAt.split(" - ")[1],
                  })
                }
                sx={{
                  ":hover": { bgcolor: "#A2E5C5" },
                }}
              >
                <EditIcon />
              </IconButton>
              {/* <IconButton
                onClick={() => {
                  setDeleteModal(true);
                  setDataTripClick(x.data);
                }}
                sx={{
                  ":hover": { bgcolor: "#A2E5C5" },
                }}
              >
                <TrashIcon />
              </IconButton> */}
            </Grid>
          );
        },
      },
    ],
    [],
  );

  const fetchMyTrips = useCallback(() => {
    setLoading(true);
    getMyTrips(`?pageIndex=${pageable.pageIndex}&pageSize=${pageable.pageSize}`)
      .then((x) => {
        setDataTrips(x.content);
        setTotalElements(x.totalElements);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageable]);

  useEffect(() => {
    fetchMyTrips();
  }, [pageable]);

  const handleDelete = () => {
    if (dataTripClick) {
      removeTripFromProject(dataTripClick.projectId, dataTripClick.id)
        .then(() => {
          setDeleteModal(false);
          getAllTrip()
            .then((x) => {
              setDataTrips(x);
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  };

  return (
    <>
      {loading && <Loader />}
      {tripDigest && (
        <CreateTripPop
          tripDigest={tripDigest}
          onClose={() => setTripDigest(undefined)}
          edit={true}
        />
      )}
      {!tripDigest && (
        <>
          <DeleteAlertModal
            handleDelete={handleDelete}
            open={deleteModal}
            setOpen={setDeleteModal}
          />

          <CustomTable
            columns={colDefs}
            rowData={dataTrips}
            refetching={loading}
            totalElements={totalElements}
            onPageChange={(pageIndex, pageSize) => {
              setPageable({
                pageIndex: pageIndex,
                pageSize: pageSize,
              });
            }}
            pageSize={pageable.pageSize}
            currentPage={pageable.pageIndex}
          />
        </>
      )}
    </>
  );
}
